import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const RegistrationPub = () => {
  return (
    <React.Fragment>
      <SEO title="Public Registration | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Public Registration"
        content="For Authors"
        contentTwo="Public Registration"
        linkage="/registration_pub"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>

        <div className="entry-content2">
        <h3>Public Registration</h3>
        <br />

        {/* <h5>Author registration and public registration will open later.</h5> */}
        <p>

          ICSI&apos;2026 is a premier forum for researchers and practitioners to present and discuss the latest advancements in swarm intelligence and related fields. The conference will feature keynote speeches, paper presentations, workshops, and panel discussions, covering a wide range of topics related to swarm intelligence.
          <br></br>
          <br></br>
          By registering for ICSI&apos;2026, you will have the opportunity to connect with experts and peers from around the world, learn about cutting-edge research and technologies, and participate in engaging discussions and activities.
          <br></br>
          <br></br>

          To register for ICSI&apos;2026, please follow the following instructions. We look forward to seeing you at the conference!
        </p>
        <br />
          <table>
            <tr>
              <td>
                <h5>Step 1.</h5>
              </td>
              <td>
                <div className="double-reg">
                  <Link
                    className="btn btn-primary btn-hover-secondary  mt-s"
                    to={process.env.PUBLIC_URL + "/paych_pub"}
                  >
                    Pay Registration Fee (RMB payment)
                  </Link>
                  <div className="space2">
                    <p>OR</p>
                  </div>
                  <Link
                    className="btn btn-primary btn-hover-secondary  mt-s"
                    to={process.env.PUBLIC_URL + "/pay_pub"}
                  >
                    Pay Registration Fee (non-RMB payment)
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <h5>Step 2.</h5>
              </td>
              <td>
                <Link
                  className="btn btn-primary btn-hover-secondary mt-s"
                  to={process.env.PUBLIC_URL + "/form_pub"}
                >
                  Fill Online Registration Form
                </Link>
              </td>
            </tr>

          </table>
          <br />
          <h3 className="note">Note</h3>
          <br />
          <p>
            <span className="lm">Registration Deadline: July 11th, 2026</span>
          </p>
        </div>
        <div className="space-120"></div>
        <div className="author reg">
          <h5>
            If you are an author of ICSI &apos;2026 and would like to view
            previous registration pages, please visit the Link below.
          </h5>
          <Link
            className="btn btn-primary btn-hover-secondary  mt-s"
            to={process.env.PUBLIC_URL + "/registration"}
          >
            Author Registration
          </Link>
        </div>
      </EmptyTwo>
      {/* <p>2. With the progress of global mass vaccination and considering the good epidemic situation in China, we have great confidence to hold the ICSI&apos; 2026 normally, so you are encouraged to attend our event to give oral presentations and communication onsite. However, there is still able to provide an opportunity of online presentation for those who are unable to join us onsite according to prevention policy.</p> */}
      {/* <p>3. CANCELLATION &amp; REFUND Policy: All cancellations must be sent in writing to the
              conference secretariat. Your payment minus 15% of total amount of registration fee
              for administrative costs will be refunded if your cancellation notice is received
              before April 30, 2026, otherwise no refund will be made after the registration
              deadline.</p> */}

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default RegistrationPub;
